/**
 * Sequential stop names. A rewritten route must not keep "Waypoint 3" on what
 * is now the first stop — those numbers are an index, not a place name.
 */

const GENERIC = /^(waypoint|stop|wp)\s*#?\s*\d+$/i;

export function isGenericWaypointLabel(label?: string | null): boolean {
  return !label || !label.trim() || GENERIC.test(label.trim());
}

export function sequentialWaypointLabel(
  label: string | null | undefined,
  index: number,
): string {
  if (isGenericWaypointLabel(label)) return `Waypoint ${index + 1}`;
  return (label || '').trim();
}
